module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-1_DE-adcc9fa3c93dddeae099eb2a52c8186d.svg";